// @flow
import {
  REMOVE_CREDENTIALS,
} from 'fc-auth/src/constants'

// Sagas
import watchLogin from './login'

import watchReceiveToken from './receiveToken'

// Storage
import storage from 'fc-storage'

// Effect Managers
import { fork, take } from 'redux-saga/effects'

// Exports
export default function *watchRemoveCredentials (): Generator<*, *, *> {
  yield take(REMOVE_CREDENTIALS)
  yield fork([storage, storage.removeItem], 'token')
  yield fork(watchLogin)
  yield fork(watchReceiveToken)
}
